export default "__VITE_ASSET__BLqRx1hK__"